import { flow, types } from 'mobx-state-tree';
import { Report, ReportTypes, MediaSpecificUserUsageWithDuration } from '../types';
import { getSingleReport, getMediaSpecificUserUsage } from '../services/reportApi';
import { composeError } from '../utils/transforms';
import { withRootStore } from './withRootStore';

export const ReportStore = types
  .model({
    selectedReport: types.maybeNull(types.frozen<Report>()),
    mediaSpecificUserUsage: types.maybeNull(types.frozen<MediaSpecificUserUsageWithDuration>()),
    loading: types.optional(types.boolean, false),
    mediaUsageLoading: types.optional(types.boolean, false),
  })
  .extend(withRootStore)
  .actions((self) => {
    const getReport = flow(function* (type: ReportTypes) {
      self.loading = true;
      try {
        const response = yield getSingleReport(type);
        self.selectedReport = response.data;
      } catch (err) {
        const error = composeError(err);
        self.rootStore.errorStore.setError(error.message);
        console.error(err);
      } finally {
        self.loading = false;
      }
    });

    const getMediaSpecificUsage = flow(function* (
      startDate: string,
      endDate: string,
      mediaId: number,
      mediaType: string,
      timeTrackedOnly?: boolean
    ) {
      self.mediaUsageLoading = true;
      try {
        const response = yield getMediaSpecificUserUsage(startDate, endDate, mediaId, mediaType, timeTrackedOnly);
        self.mediaSpecificUserUsage = response;
      } catch (err) {
        const error = composeError(err);
        self.rootStore.errorStore.setError(error.message);
        console.error(err);
      } finally {
        self.mediaUsageLoading = false;
      }
    });

    const clearMediaSpecificUsage = () => {
      self.mediaSpecificUserUsage = null;
    };

    return {
      getReport,
      getMediaSpecificUsage,
      clearMediaSpecificUsage,
    };
  });
